import { render, staticRenderFns } from "./UpdateMemberRoleModal.vue?vue&type=template&id=47696bfb&"
import script from "./UpdateMemberRoleModal.vue?vue&type=script&lang=js&"
export * from "./UpdateMemberRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports